module.exports = __webpack_public_path__ + "static/img/2.60912fb8.png";